<script>
  import FileInput from '~componentes/InputFile.vue'
  
  export default {
    components: { FileInput },
    data() {
      return {
        arquivos: new Array(6),
      }
    },
    methods: {
      adicionarArquivo() {
        this.arquivos.push(null);
      },
      limparArquivos() {
        while (this.arquivos.length != 0) {
          this.arquivos.pop();
        }

        for (var i = 0; i < 6; i++) {
          this.adicionarArquivo();
          this.$refs.fileInput[i].removerArquivo();
        }
      },
      existeArquivo() {
        let existeArquivo = false;
        for (let arquivo of this.arquivos) {
          if (arquivo) {
            existeArquivo = true;
            break;
          }
        }
        return existeArquivo;
      },
      emitChanges() {

        let a = []
        for (let arquivo of this.arquivos) {
          if (arquivo) {
            a.push(arquivo.name)
          }
        }
        this.$emit('input', a);
      },
    }
  }
</script>

<template>
  <div>
    <template v-for="(arquivo, indice) in arquivos">
      <file-input v-model="arquivos[indice]" @input="emitChanges()" ref="fileInput"></file-input>
    </template>
    
    <button type="button" class="btn btn-success" @click="adicionarArquivo">
      <i class="fa fa-plus"></i> Adicionar mais arquivos
    </button>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/FormAdicionarArquivos.vue